module.exports = "/desktop-app/assets/img/mes-logo.png?03234c3bc4641e4c176378a419ff58c1";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/chat/mes-logo.png
// module id = D2os
// module chunks = 1